module.exports = __webpack_public_path__ + "fonts/Caveat-400-cyrillic-ext1.fe4233b.woff2";